import styled from 'styled-components'

import { media } from 'styles/media'
import typeStyle from 'styles/typeStyle'

export const SecondaryHeading = styled.h2`
  ${typeStyle('-ds-font-title-1-regular')}
  line-height: 1.1;
  margin-bottom: 16px;
  text-align: center;

  margin-top: 80px;

  ${media.md`
    margin-top: 120px;
  `}
`

export const Subheading = styled.p`
  ${typeStyle('-ds-font-section-title-light')}
  text-align: center;
`

export const SpacingWrapper = styled.div`
  margin-top: 80px;

  ${media.md`
    margin-top: 120px;
  `}
`
